<template>
  <div class="contr-section-page">
    <div class="banner" @click.self="changeHandle">智能合约</div>
    <div class="animation-box">
      <div class="animation-left"></div>
      <div class="animation-right"></div>
    </div>
    <div class="content-wrapper" style="height: 100%;">
      <el-table
        height="100%"
        :data="contractList">
        <el-table-column
          prop="contractAddr"
          label="智能合约地址">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>{{ scope.row.contractAddr }}</p>
              <div slot="reference" class="hash-wrapper">
                {{ scope.row.contractAddr }}</div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          prop="txCount_1"
          label="交易次数">
        </el-table-column>
        <el-table-column
          prop="creator"
          label="创建人账户">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>{{ scope.row.creator }}</p>
              <div slot="reference" class="hash-wrapper">
                {{ scope.row.creator }}</div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="txHash"
          label="合约来源">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>{{ scope.row.txHash }}</p>
              <div slot="reference" class="hash-wrapper">
                {{ scope.row.txHash }}</div>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="content-four">
      <p class="label">智能合约</p>
      <div class="inner-box">
        <img class="icon" :src="themeData ? require('../assets/icon/contr-1Icon@2x.svg') : require('../assets/icon/contr-1Icon@2x_1.svg')" alt="">
        <div class="list-box">
          <p class="list-item" v-for="(item, index) in listMode" :key="index">{{item.label}}:<span class="text">{{item.value}}</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lottie from 'lottie-web'
let echarts = require('echarts')
export default {
  data() {
    return {
      contractList: [],
      contrChart: '',
      animLeft: null
    }
  },
  components: {},
  computed: {
    listMode () {
      if (this.contractList[0]) {
        let obj = this.contractList[0]
        return [
          {
            label: '合约地址',
            value: obj['contractAddr']
          },{
            label: '创建人',
            value: obj['creator']
          },{
            label: '合约来源',
            value: obj['txHash']
          },{
            label: '交易次数',
            value: obj['txCount_1']
          }
        ]
      } else {
        return []
      }
    },
    themeData() {
      return this.$attrs.themeData
    }
  },
  mounted() {
    // this.initCanvas()
    this.fetchContractList()
    this.fetchMSPCtro()
    this.initchart()
  },
  methods: {
    initchart() {
      // let _this = this
      // this.contrChart = echarts.init(document.querySelector(".chart-box-one"))
      // window.addEventListener('resize', () => {
      //   _this.contrChart.resize()
      // })
      // this.renderContrChart()
    },
    renderContrChart() {
      let initOption = {
        color: ['#0033CC', '#0099FF', '#00FFFF', '#009966', '#006666'],
        title: {
          text: '合约调用量'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          data: []
        },
        grid: {
          left: 10,
          right: 10,
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: ['4月', '5月', '6月', '7月', '8月', '9月', '10月']
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
        ]
      };
      this.contrChart.setOption(initOption)
      this.contrChart.resize()
    },
    changeHandle() {
      let pageRoot = document.querySelector('.contr-section-page')
      this.$emit('callback', pageRoot)
    },
    async fetchContractList () {
      let contrList = await this.$http({
        "method":"eth_getContracts",
        "params":['0', '100'],
        "id":1})

      contrList.map(item => {
        item.timestamp_1 = parseInt(item.timestamp, 16)
        item.txCount_1 = parseInt(item.txCount, 16)
      })

      this.contractList = contrList
      this.fetchFiveContractUse()
    },
    fetchFiveContractUse() {
      let _this = this
      let arry = this.contractList.slice(0,6)
      console.log(arry)
      arry.map(item => {
        _this.fetchContractUse(item.contractAddr)
      })
    },
    async fetchContractUse(address) {
      let time = new Date()
      time.setMonth(time.getMonth() - 1)
      let utcTime = (Math.round(time.getTime()/1000)).toString()
      let lineData = await this.$http({
        "method":"eth_GetContractCallNumByTimeStampAndAddress",
        "params":[utcTime, address],
        "id":1
      })
      console.log(lineData)
    },
    fetchMSPCtro () {
      this.$http({
        "method":"net_sysContract",
        "params":[],
        "id":1
      }).then(res => {
        // console.log(res)
        this.reloadAnimation(res)
      })
    },
    reloadAnimation (data) {
      let leftDom = document.querySelector('.animation-left')
      let rightDom = document.querySelector('.animation-right')
      let aniLeftPath1 = require('../assets/animation/data6.json')
      let aniLeftPath2 = require('../assets/animation/data7.json')
      // console.log(data.MspContract)

      if (this.animLeft) {
        this.animLeft.destroy()
      }

      if (this.animRight) {
        this.animRight.destroy()
      }

      this.animLeft = lottie.loadAnimation({
        container: leftDom,
        renderer: 'svg',
        loop: false,
        autoplay: true,
        animationData: aniLeftPath1,
      })

      this.animLeft.addEventListener('complete', () => {
        let element_1 = document.getElementById('xq_1')
        element_1.innerHTML = `<text stroke-linecap="butt" stroke-linejoin="round" stroke-miterlimit="4" xml:space="preserve" style="display: inherit;" transform="matrix(1,0,0,1,0,0)" opacity="1">${data.MspContract.slice(0, 20)}</text>
        <text stroke-linecap="butt" stroke-linejoin="round" stroke-miterlimit="4" xml:space="preserve" style="display: inherit;" transform="matrix(1,0,0,1,0,25)" opacity="1">${data.MspContract.slice(20, 40)}</text>
        <text stroke-linecap="butt" stroke-linejoin="round" stroke-miterlimit="4" xml:space="preserve" style="display: inherit;" transform="matrix(1,0,0,1,0,49)" opacity="1">${data.MspContract.slice(40, data.MspContract.length)}</text>`
      })


      let animRight = lottie.loadAnimation({
        container: rightDom,
        renderer: 'svg',
        loop: false,
        autoplay: true,
        animationData: aniLeftPath2
      })

      animRight.addEventListener('complete', () => {
        let element_2 = document.getElementById('xq_2')
        element_2.innerHTML = `
        <text stroke-linecap="butt" stroke-linejoin="round" stroke-miterlimit="4" xml:space="preserve" style="display: inherit;" transform="matrix(1,0,0,1,0,0)" opacity="1">${data.DposPbft.slice(0, 20)}</text>
        <text stroke-linecap="butt" stroke-linejoin="round" stroke-miterlimit="4" xml:space="preserve" style="display: inherit;" transform="matrix(1,0,0,1,0,25)" opacity="1">${data.DposPbft.slice(20, 40)}</text>
        <text stroke-linecap="butt" stroke-linejoin="round" stroke-miterlimit="4" xml:space="preserve" style="display: inherit;" transform="matrix(1,0,0,1,0,49)" opacity="1">${data.DposPbft.slice(40, data.DposPbft.length)}</text>`
      })
    },
  }
}
</script>

<style lang="scss">
@import '@/assets/css/init-css.scss';

$area-radius: 25px;
$area-margin: .2rem;

.contr-section-page {
  position: relative;
  .banner {
    // color: #fff;
    top: 0;
    font-weight: bold;
    position: absolute;
    z-index: 1000;
  }

  .animation-box {
    display: flex;
    >div {
      flex: 1
    }
  }

  .content-wrapper {
    height: 100%;
    .content-three {
      background: $area-background;
      border-radius: $area-radius;
    }
  }



  .el-table {
    background: none;
  }

  //-------------置中样式
  &.section-center {
    // display: flex;
    // flex-direction: column;
    padding-top: 70px;
    .banner {
      font-size: .25rem;
    }

    .chart-box-one {
      height: 50%;
    }

    .animation-box {
      display: none;
    }


    .content-wrapper {
      height: 50%;
      overflow: hidden;
      border-radius: 10px;
      .content-two {
        width: 100%;
      }
    }

    .content-four {
      display: none;
    }
  }


  //-------------左上样式

  &.section-left {
    border-radius: $area-radius;
    background: $area-background;
    padding: .2rem .4rem;
    box-sizing: border-box;
    .banner {
      font-size: .25rem;
      position: absolute;
      top: .2rem;
      left: .4rem;
    }

    .animation-box {
      height: 30%;
      padding-top: 10%;
      box-sizing: border-box;
    }

    .content-wrapper {
      height: 60%;
    }

    .content-three, .content-four {
      display: none;
    }
  }

  //-------------左下右下样式
  &.section-bottom-left, &.section-bottom-right {
    border-radius: $area-radius;
    background: $area-background;
    padding: .2rem .4rem;
    box-sizing: border-box;
    .content-wrapper, .banner {
      display: none;
    }

    .animation-box {
      height: 50%;
    }

    .content-four {
      .label {
        //color: #fff;
        font-weight: bold;
        font-size: .25rem;
        text-align: left;
      }
      .inner-box {
        display: flex;
        .icon {
          width: .5rem;
          height: .5rem;
          margin-top: .1rem;
        }
        .list-box {
          margin-left: .2rem;
          width: 80%;
          .list-item {
            font-size: .16rem;
            text-align: left;
            line-height: 2;
            display: flex;
            >span {
              flex: 1;
              display: inline-block;
              margin-left: .1rem;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }
        }
      }
    }
  }

}

</style>
